import React, { useEffect, useState } from "react";
import { ActivityFrequencyRelation, Result } from "../../interface/ActivityFrequencyRelation";
import { ActivityFrequencyRelationAxiosInstance } from "../../Network/ActivityFrequencyRelation";
import { AxiosResponse, AxiosError} from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Option } from "../../interface/Option";
import ListOfCustomActivities from "../Shared/ListOfActivities";
import ActivitySelector from "../Shared/ActivityType"; 
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import { toast, ToastContainer } from "react-toastify";

const RelationActivityFrequency: React.FC = () => {
  const [items, setItems] = useState<ActivityFrequencyRelation>({ result: [] });
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [ActivityType, setActivityType] = useState<string>("");
  const [AllowedValues, setAllowedValues] = useState<number | undefined>();
  const [Perdays, setperdays] = useState<string>("");
  const [Fors, setFors] = useState<string>("");
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [clearSelectedActivities, setClearSelectedActivities] = useState(false);
  const [selectedActivitiesisValid, setSelectedActivitiesIsValid] = useState<boolean>(true); 
  const [selectedActivitiesError, setSelectedActivitiesError] = useState<string>("");
  const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true); 
  const [activityTypeError, setActivityTypeError] = useState<string>("");
  const [allowedValuesisValid, setAllowedValuesIsValid] = useState<boolean>(true); 
  const [allowedValuesError, setAllowedValuesError] = useState<string>("");
  const [forsisValid, setForsIsValid] = useState<boolean>(true); 
  const [forsError, setForsError] = useState<string>("");
  const token = localStorage.getItem('token') || "";
  useEffect(() => {
    fetchItems();
  }, []);
  useEffect(() => {
    if (clearSelectedActivities) {
      setClearSelectedActivities(false); 

      // clear select option for SelectedActivities
    }
  }, [clearSelectedActivities]);
  const clear= ()=>{
    setSelectedActivities([]);
    setActivityType("");
    setAllowedValues(undefined);
        setperdays("");
    setFors("");
    setClearSelectedActivities(true); 
 }
 const handleSelectedActivitiesBlur = (): void => {
  if (!selectedActivities || selectedActivities.length === 0) {
    setSelectedActivitiesError("Code are required");
    setActivityTypeIsValid(false);
  } else {
    setSelectedActivitiesError("");
    setActivityTypeIsValid(true);
  }
};
const SelectedActivitiesvalidate = (): boolean => {
  if (!selectedActivities || selectedActivities.length === 0) {
    setSelectedActivitiesError("Code is required");
    setActivityTypeIsValid(false); 
    return false;
  }
  
  setSelectedActivitiesError("");
  setActivityTypeIsValid(true);

  return true;
};
  const handleActivityTypeBlur = (): void => {
    if (!ActivityType.trim()) {
      setActivityTypeError("Type is required");
      setActivityTypeIsValid(false); 
  
    } else {
      setActivityTypeError("");
      setActivityTypeIsValid(true);
    }
  };
    const ActivityTypevalidate = (): boolean => {
      if (!ActivityType.trim()) {
        setActivityTypeError("Type is required");
        setActivityTypeIsValid(false); 
  
        return false;
      }
      setActivityTypeError("");
      setActivityTypeIsValid(true);
  
      return true;
    };
    const handleAllowedValuesBlur = (): void => {
      if (!AllowedValues ) {
        setAllowedValuesError("AllowedValues are required");
        setAllowedValuesIsValid(false);
      } else {
        setAllowedValuesError("");
        setAllowedValuesIsValid(true);
      }
    };
    const AllowedValuesvalidate = (): boolean => {
      if (AllowedValues === undefined) {
        setAllowedValuesError("AllowedValues is required");
        setAllowedValuesIsValid(false);
        return false;
      }
      
      setAllowedValuesError("");
      setAllowedValuesIsValid(true);
      return true;
    };
    const validateAllowedValues = (value: number | undefined) => {
      if (value === undefined) {
          setAllowedValuesError("AllowedValues is required");
          setAllowedValuesIsValid(false);
          return false;
      }
      
      setAllowedValuesError("");
      setAllowedValuesIsValid(true);
      return true;
  };
    const handleForsBlur = (): void => {
      if (!Fors.trim()) {
        setForsError("Fors is required");
        setForsIsValid(false); 
    
      } else {
        setForsError("");
        setForsIsValid(true);
      }
    };
    const handleForsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setFors(value);
      // Check as you type
      Forsevalidate(value);  
  };
  const validateFors = (): boolean => {
    if (!Fors.trim()) {
      setForsError("Fors is required");
      setForsIsValid(false); 
      return false;
    }
    
    setAllowedValuesError("");
    setAllowedValuesIsValid(true);
    return true;
  };
  const Forsevalidate = (value: string): boolean => { 
      if (!value.trim()) { 
          setForsError("Fors is required");
          setForsIsValid(false); 
          return false;
      }
      setForsError("");
      setForsIsValid(true);
      return true;
  };
  const handleActivitiesChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedActivities(selectedOptions);
    console.log(setSelectedActivities)
   
  };
  const handleActivityTypeChange = (ActivityType: string) => {
    setActivityType(ActivityType); //Update the status of the selected activityType
  };
  const handleAllowedValuesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === "") {
        setAllowedValues(undefined); // If the entry is empty, set undefined
        setAllowedValuesError(""); 
    } else {
        const numberValue = Number(value); 
        setAllowedValues(numberValue);
        validateAllowedValues(numberValue);
    }
};

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await ActivityFrequencyRelationAxiosInstance.get("getfrequencyrelation");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const addItem = async (): Promise<void> => {
    const isFormValid = ActivityTypevalidate();
    const isForm2Valid = SelectedActivitiesvalidate();
    const isForm3Valid = AllowedValuesvalidate();
    const isForm4Valid = validateFors();
    if (!isFormValid || !isForm2Valid ||!isForm3Valid||!isForm4Valid) {
      return;
    }
    const activities = selectedActivities.map(option => option.value); 

    try {
      const NewRelation = {
        code: activities,
        type: ActivityType,
        Allowedvalues:AllowedValues,
        perDays:Perdays,
        fors:Fors,
        token,
      };
      const response = await ActivityFrequencyRelationAxiosInstance.post("addfrequencyrelation",NewRelation );
      
      if (response.data.success) {
        fetchItems(); 
        clear(); 
        setActivityTypeIsValid(true); 
        setSelectedActivitiesIsValid(true); 
        setForsIsValid(true);
        setAllowedValuesIsValid(true);

        
        toast.success("New network added successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
        setActivityTypeIsValid(false); 
        setSelectedActivitiesIsValid(false); 
        setForsIsValid(false);
        setAllowedValuesIsValid(false);
        toast.error(`${error.response.data.error}`);
      } else {
// If there is another error unrelated to the response such as a connection interruption
      toast.error('An unexpected error occurred.');
      }
    }
  }    

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await ActivityFrequencyRelationAxiosInstance.delete(`deletefrequencyrelation/${id}`, {
        data: { token },
      });
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
      toast.error("Error removing item:");
    }
  };
const updateItem = async (id: string | number): Promise<void> => {
    const isFormValid = ActivityTypevalidate();
    const isForm2Valid = SelectedActivitiesvalidate();
    const isForm3Valid = AllowedValuesvalidate();
    const isForm4Valid = validateFors();
    if (!isFormValid || !isForm2Valid ||!isForm3Valid||!isForm4Valid) {
      return;
    }
    const activities = selectedActivities.map(option => option.value); 

    try {
      const updatedItem = {
        code: activities,
        type: ActivityType,
        Allowedvalues:AllowedValues,
        perDays:Perdays,
        fors:Fors,
        id: id,
        token,
      };
 
   const response = await ActivityFrequencyRelationAxiosInstance.put("updatefrequencyrelation", updatedItem);
  if (response.data.success) {
        fetchItems(); 
        clear(); 
       
        setActivityTypeIsValid(true); 
        setSelectedActivitiesIsValid(true); 
        setForsIsValid(true);
        setAllowedValuesIsValid(true);
        toast.success("New network update successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
    
        toast.error(`${error.response.data.error}`);
      } else {
// If there is another error unrelated to the response such as a connection interruption
        toast.error('An unexpected error occurred.');
      }
    }
  };

  const handleEdit =  (item: Result) => {
    const code = (item.code || []).map((codes: string) => ({
      label: codes,
      value: codes,
  }));

  setSelectedActivities(code);
  setActivityType(item.type);
  setAllowedValues(item.allowedvalues);

  // Convert the date manually without being affected by UTC
  const date = new Date(item.perdays);
  const formattedDate = date.getFullYear() + '-' + 
                        String(date.getMonth() + 1).padStart(2, '0') + '-' + 
                        String(date.getDate()).padStart(2, '0');
  
  setperdays(formattedDate); 

  setFors(item.fors);
  setEditIndex(item.id);
  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
   
    {
      accessorKey: "code",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
CODE
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("code") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },

    {
      accessorKey: "type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 TYPE
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
      {
      accessorKey: "allowedvalues",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        AllowedValues
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "perdays",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          perdays
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ getValue }) => {
        const date = new Date(getValue() as string);
        return date.toLocaleDateString('en-GB');
      },
    },
    
     {
      accessorKey: "fors",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Fors
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
  ];


  
   return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
      RelationActivityFrequency{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
    
      {/* model */}
      {/* tabIndex="-1" */}
      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={(e) => { 
                  setEditIndex(null);
                   clear(); 
                   setActivityTypeIsValid(true); 
                   setSelectedActivitiesIsValid(true); 
                   setActivityTypeError(''); 
                   setSelectedActivitiesError(''); 
                   setForsIsValid(true);
                   setAllowedValuesIsValid(true);
                   setAllowedValuesError('')
                   setForsError('')
                 }}
              >
                {" "}
              </button>
            </div>
            <div className=" container d-flex flex-column align-items-center ">
            <div style={{ margin: "15px"  ,width:"80%"} }>
            <div style={{ marginTop: "10px",width:"500PX"}}>
              <label className="form-label">Type:</label>
              <div    onBlur={handleActivityTypeBlur} >            
              <ActivitySelector 
  onSelectActivity={handleActivityTypeChange}
  selectedActivityType={ActivityType} 
/>
</div>
{ activityTypeError&& <div style={{ color: "red" }}>{activityTypeError}</div>}
</div>

<div style={{ marginTop: "10px",width:"500PX"}}>
              <label className="form-label">Code:</label>
              <div    onBlur={handleSelectedActivitiesBlur}  >            

<ListOfCustomActivities
  isValid={ activityTypeisValid}
  onChange={handleActivitiesChange}
  selectedActivityType={ActivityType}
  defaultValue={selectedActivities}
/>
 </div>
 { selectedActivitiesError&& <div style={{ color: "red" }}>{selectedActivitiesError}</div>}

</div>
        <div style={{ marginBottom: "10px" }}>
              <label className="form-label">
              AllowedValues:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={AllowedValues !== undefined ? AllowedValues : ""}
                        style={{ marginBottom: "7px"         ,  
                          borderColor: !allowedValuesisValid ?  "red": "", 
                          transition: "border-color 0.3s",
                        }}
                        onBlur={handleAllowedValuesBlur} 
                        onChange={handleAllowedValuesChange}
                        />
                        { allowedValuesError&& <div style={{ color: "red" }}>{allowedValuesError}</div>}

              </div>
              <div style={{ marginBottom: "10px" }}>
              <label className="form-label">
              Perdays:
                      </label>
                    
              <input type='date' className='form-control' value={Perdays} onChange={(e) => setperdays(e.target.value)}  />
              </div>
              <div style={{ marginBottom: "10px" }}>
              <label className="form-label">For: </label>
                      <input
                       style={{ marginBottom: "7px"         ,  
                        borderColor: !forsisValid ?  "red": "", 
                        transition: "border-color 0.3s",
                      }}
                        type="text"
                        className="form-control"
                        value={Fors}
                        onBlur={handleForsBlur} 
                        onChange={handleForsChange}                   />
                                   { forsError&& <div style={{ color: "red" }}>{forsError}</div>}

              </div> 
              </div>
  </div>
           <div className="modal-footer">
            <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }        
                disabled={!selectedActivitiesisValid || !activityTypeisValid || !allowedValuesisValid || !forsisValid }

                >
                {editIndex === null ? "Add Item" : "Update Item"}
                </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => { 
                  setEditIndex(null);
                   clear(); 
                   setActivityTypeIsValid(true); 
                   setSelectedActivitiesIsValid(true); 
                   setActivityTypeError(''); 
                   setSelectedActivitiesError(''); 
                   setForsIsValid(true);
                   setAllowedValuesIsValid(true);
                   setAllowedValuesError('')
                   setForsError('')
                 }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

<DataTable
  columns={columns}
  data={items.result}
  searchColumn="allowedvalues"
  addButtonLabel="Add New Relation" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </div>
  );
};

export default RelationActivityFrequency;



   
  
  
  
